import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * Renders children only if user has the given permission (or is admin).
 * If `redirect` is true, redirects to /unauthorized instead of rendering null.
 */
export function PermissionGate({ permission, children, fallback = null, redirect = false }) {
  const { hasPermission } = useAuth();
  if (hasPermission(permission)) return children;
  if (redirect) return <Navigate to="/unauthorized" replace />;
  return fallback;
}
